// removed by extract-text-webpack-plugin
module.exports = {"productPage_related":"ProductPage-m__productPage_related___3pXRW","productPageRelated":"ProductPage-m__productPage_related___3pXRW","productPage_relatedHeader":"ProductPage-m__productPage_relatedHeader___2WAWK","productPageRelatedHeader":"ProductPage-m__productPage_relatedHeader___2WAWK","productPage_mobileDesc":"ProductPage-m__productPage_mobileDesc___1FpwS","productPageMobileDesc":"ProductPage-m__productPage_mobileDesc___1FpwS"};


//////////////////
// WEBPACK FOOTER
// ./containers/productPage/ProductPage.m.sass
// module id = Xmwi
// module chunks = 0